module.exports = __webpack_public_path__ + "img/not_found.1feced7a.gif";